export const GEOCODE_FIELDS = [
    { id: 'address', label: 'Address' },
    { id: 'city', label: 'City/State' },
    { id: 'zip', label: 'ZIP Code' },
    { id: 'county', label: 'County Name' },
];

export const GEOJSON_FILENAME = 'geoJson.json';
